import React from "react";
import { ChevronDown, ArrowDown } from "lucide-react"; // Optional: for arrows, or use custom CSS

const BoardofGovernors = () => {
  const bogMembers = [
    {
      id: 1,
      name: "Smt. Surapaneni Sri Jyothi",
      designation: "President",
      representative: "President of the society",
    },
    {
      id: 2,
      name: "Sri Dr.D. Prasad",
      designation: "Member",
      representative: "Vice – President of the society",
    },
    {
      id: 3,
      name: "Sri. Surapaneni Venkata Ramana",
      designation: "Member",
      representative: "Secretary & Correspondent of the society",
    },
    {
      id: 4,
      name: "Sri. Mokkapati Srinivas",
      designation: "Member",
      representative: "Joint Secretary of the society",
    },
    {
      id: 5,
      name: "Sri Potla Sai Kumar",
      designation: "Member",
      representative: "Treasurer of the society",
    },
    {
      id: 6,
      name: "Sri Kommineni Nishnath",
      designation: "Member",
      representative: "E.C. Member of the society",
    },
    {
      id: 7,
      name: "Smt. Mokkapati Chitra Lakshmi Prasanna Kumari",
      designation: "Member",
      representative: "E.C. Member of the society",
    },
    {
      id: 8,
      name: "The Regional Officer",
      designation: "Member (AICTE)",
      representative: "Regional Officer South Central Region, Hyderabad",
    },
    {
      id: 9,
      name: "The Secretary",
      designation: "Member (SBTET)",
      representative: "SBTET, Mangalagiri",
    },
    {
      id: 10,
      name: "Regional Joint Director",
      designation: "Member (CTE)",
      representative: "RJD, AU Region, Kakinada",
    },
    {
      id: 11,
      name: "The Principal",
      designation: "Member Secretary",
      representative: "Principal, Sri Jyothi Polytechnic",
    },
  ];

  const societyMembers = [
    {
      id: 1,
      name: "Smt. Surapaneni Sri Jyothi",
      designation: "President",
      background:
        "Member since 2010. Educational awareness advocate in rural areas.",
    },
    {
      id: 2,
      name: "Sri Dr.D. Prasad",
      designation: "Vice – President",
      background: "Member since 2017. Philanthropist and education promoter.",
    },
    {
      id: 3,
      name: "Sri. Surapaneni Venkata Ramana",
      designation: "Secretary & Correspondent",
      background:
        "Member since 2010. 30 years experience in technical education management.",
    },
    {
      id: 4,
      name: "Sri. Mokkapati Srinivas",
      designation: "Joint Secretary",
      background:
        "Member since 2010. Graduate engaged in building construction activity.",
    },
    {
      id: 5,
      name: "Sri Potla Sai Kumar",
      designation: "Treasurer",
      background: "Member since 2020. Graduate involved in Accounts.",
    },
    {
      id: 6,
      name: "Sri Kommineni Nishnath",
      designation: "E.C. Member",
      background:
        "Member since 2020. Graduate interested in teaching and education.",
    },
    {
      id: 7,
      name: "Smt. Mokkapati Chitra Lakshmi Prasanna Kumari",
      designation: "E.C. Member",
      background:
        "Member since 2010. Graduate interested in teaching and education.",
    },
  ];

  const programmes = [
    {
      name: "Artificial Intelligence & Machine Learning",
      code: "DAIM",
      intake: 180,
    },
    { name: "Computer Engineering", code: "DCME", intake: 90 },
    { name: "Cloud Computing & Big Data", code: "DCCB", intake: 60 },
    { name: "Electronics & Communication Engg", code: "DECE", intake: 60 },
    { name: "Civil Engineering", code: "DCE", intake: 30 },
    { name: "Electrical & Electronics Engg", code: "DEEE", intake: 30 },
    { name: "Mechanical Engineering", code: "DME", intake: 30 },
  ];

  return (
    <div className="bg-gray-50 min-h-screen font-sans text-gray-900 pb-20">
      {/* Hero Header */}
      <div className="bg-blue-900 text-white py-16 px-4 text-center">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-4 uppercase tracking-tight">
          Board of Governors & Mandatory Disclosures
        </h1>
        <p className="text-blue-200 max-w-3xl mx-auto text-lg italic">
          Transparency and Governance details of Sri Jyothi Polytechnic,
          Kalavapamula
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Sidebar Nav (Desktop Only) */}
<aside className="hidden lg:block space-y-2 sticky top-10 h-fit">
  <h3 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4">
    Jump to Section
  </h3>
  {[
    { name: "Org Chart", id: "org-chart" },
    { name: "Governance", id: "governance" },
    { name: "Institution Info", id: "institution-info" },
    { name: "Society", id: "society" },
    { name: "Programmes", id: "programmes" },
    { name: "Infrastructure", id: "infrastructure" },
    { 
      name: "References", 
      url: "https://srijyothipolytechnic.com/board-of-governors-mandatory-disclosures/mandatory-disclosures.pdf" 
    },
  ].map((item) => (
    item.url ? (
      /* External Link for References */
      <a
        key={item.name}
        href={item.url}
        target="_blank"
        rel="noopener noreferrer"
        className="block w-full text-left px-4 py-2 text-sm font-semibold rounded-lg hover:bg-blue-50 text-gray-600 hover:text-blue-700 transition"
      >
        {item.name}
      </a>
    ) : (
      /* Internal Button for sections */
      <button
        key={item.name}
        onClick={() => document.getElementById(item.id)?.scrollIntoView({ behavior: 'smooth' })}
        className="w-full text-left px-4 py-2 text-sm font-semibold rounded-lg hover:bg-blue-50 text-gray-600 hover:text-blue-700 transition"
      >
        {item.name}
      </button>
    )
  ))}
</aside>

          {/* Main Content Area */}
          <div className="lg:col-span-3 space-y-12">
           

            {/* 1. Board of Governors */}
            <section className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="bg-blue-50 p-6 border-b border-gray-200">
                <h2 className="text-2xl font-bold text-blue-900">
                  Nomination of Board of Governors
                </h2>
                <p className="text-sm text-blue-700 mt-2 italic">
                  Resolved in executive meeting held on 10-11-2012 (Item
                  No.16/2012)
                </p>
              </div>
              <div className="p-6">
                <div className="overflow-x-auto">
                  <table className="w-full text-left text-sm">
                    <thead>
                      <tr className="bg-gray-50 text-gray-600 uppercase font-bold text-sm border-b">
                        <th className="px-4 py-4">Sl</th>
                        <th className="px-4 py-4">Name</th>
                        <th className="px-4 py-4">Designation</th>
                        <th className="px-4 py-4">Representation</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                      {bogMembers.map((member) => (
                        <tr
                          key={member.id}
                          className="hover:bg-blue-50/30 transition"
                        >
                          <td className="px-4 py-4 font-medium text-gray-400">
                            {member.id}
                          </td>
                          <td className="px-4 py-4 font-bold text-gray-800">
                            {member.name}
                          </td>
                          <td className="px-4 py-4 text-blue-600 font-medium">
                            {member.designation}
                          </td>
                          <td className="px-4 py-4 text-gray-600">
                            {member.representative}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </section>

            {/* 2. Mandatory Disclosure Disclaimer */}
            <div className="bg-amber-50 border-l-4 border-amber-400 p-6 rounded-r-xl">
              <h3 className="font-bold text-amber-900 mb-1">
                MANDATORY DISCLOSURES Notice:
              </h3>
              <p className="text-amber-800 text-sm italic leading-relaxed">
                "The information has been provided by the concerned institution
                and the onus of authenticity lies with the institution and not
                on CTE / State Government/ Board/ AICTE."
              </p>
            </div>

            {/* 3. Institution & Principal Details */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <Card title="I. Name of the Institution">
                <p className="font-bold text-gray-800">
                  SRI JYOTHI POLYTECHNIC
                </p>
                <p className="text-gray-600">
                  KALAVAPAMULA(V), VUYYURU(M), KRISHNA DIST, AP, 521164
                </p>
                <div className="mt-4 flex gap-4 text-xs font-mono text-blue-600">
                  <span>PH: 08674-247435</span>
                  <span>Fax: 247335</span>
                </div>
              </Card>

              <Card title="II. Name of the Principal">
                <p className="font-bold text-gray-800 uppercase">
                  JANNU SIVA KUMAR
                </p>
                <p className="text-gray-600">Gudlavalleru, AP</p>
                <div className="mt-4 text-sm space-y-1">
                  <p>
                    <strong>Mobile:</strong> 9949838413
                  </p>
                  <p>
                    <strong>Email:</strong> sivajannu@gmail.com
                  </p>
                </div>
              </Card>
            </div>

            {/* 4. Society Members List */}
            <section className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8">
              <h2 className="text-xl font-bold mb-6 border-b pb-4">
                IV. List of Society Members & Background
              </h2>
              <div className="space-y-6">
                {societyMembers.map((member) => (
                  <div
                    key={member.id}
                    className="flex flex-col md:flex-row gap-4 border-b border-gray-50 pb-6 last:border-0"
                  >
                    <div className="md:w-1/3">
                      <p className="font-bold text-gray-900">{member.name}</p>
                      <p className="text-blue-600 text-sm font-semibold">
                        {member.designation}
                      </p>
                    </div>
                    <div className="md:w-2/3 text-sm text-gray-600 bg-gray-50 p-4 rounded-lg">
                      {member.background}
                    </div>
                  </div>
                ))}
              </div>
            </section>
 {/* NEW SECTION: Organizational Chart */}
           {/* NEW SECTION: Organizational Chart */}
<section className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 overflow-x-auto">
  <h2 className="text-xl font-bold mb-10 border-b pb-4 text-blue-900">
    Organizational Chart and Processes
  </h2>

  <div className="flex flex-col items-center min-w-[700px]">
    {/* Top Level Chain */}
    <OrgBox text="SRI JYOTHI EDUCATIONAL SOCIETY" primary />
    <Connector />
    <OrgBox text="GOVERNING BODY OF THE POLYTECHNIC" />
    <Connector />
    <OrgBox text="SECRETARY & CORRESPONDENT" />
    <Connector />
    <OrgBox text="PRINCIPAL" highlight />

    {/* --- MAIN BRANCHING SECTION --- */}
    <div className="w-full flex flex-col items-center">
      {/* 1. Main vertical stem coming out of Principal */}
      <div className="h-8 w-px bg-blue-300"></div>

      {/* 2. Main horizontal bridge */}
      <div className="w-1/2 border-t-2 border-blue-300"></div>

      <div className="grid grid-cols-2 w-full">
        {/* --- LEFT BRANCH (Academic) --- */}
        <div className="flex flex-col items-center">
          {/* Stem down to the box */}
          <div className="h-8 w-px bg-blue-300"></div>
          <OrgBox text="HEAD OF THE DEPARTMENTS" small />
          <Connector />
          <OrgBox text="LECTURERS" small />
          <Connector />
          <OrgBox text="LAB TECHNICIANS" small />
        </div>

        {/* --- RIGHT BRANCH (Non-Teaching) --- */}
        <div className="flex flex-col items-center">
          {/* Stem down to the box */}
          <div className="h-8 w-px bg-blue-300"></div>
          <OrgBox text="NON-TEACHING STAFF" small />

          {/* --- SUB-BRANCHING SECTION --- */}
          <div className="w-full flex flex-col items-center">
            <div className="h-8 w-px bg-blue-300"></div>
            {/* Sub horizontal bridge */}
            <div className="w-1/2 border-t-2 border-blue-300"></div>
            
            <div className="grid grid-cols-2 w-full">
              {/* Admn Staff */}
              <div className="flex flex-col items-center">
                <div className="h-8 w-px bg-blue-300"></div>
                <OrgBox text="ADMN. STAFF" xSmall />
              </div>
              {/* Common Staff */}
              <div className="flex flex-col items-center">
                <div className="h-8 w-px bg-blue-300"></div>
                <OrgBox text="COMMON STAFF" xSmall />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
            {/* 5. Programmes Offered 2026-27 */}
            <section className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="bg-slate-900 text-white p-6">
                <h2 className="text-xl font-bold">
                  V. Programmes & Intake (Academic Year 2026-27)
                </h2>
              </div>
              <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {programmes.map((prog, i) => (
                  <div
                    key={i}
                    className="border border-gray-100 p-4 rounded-xl flex justify-between items-center hover:border-blue-200 transition"
                  >
                    <div>
                      <p className="text-[10px] font-bold text-gray-400">
                        {prog.code}
                      </p>
                      <p className="font-semibold text-gray-800 text-sm">
                        {prog.name}
                      </p>
                    </div>
                    <div className="bg-blue-100 text-blue-700 font-bold px-3 py-1 rounded text-lg">
                      {prog.intake}
                    </div>
                  </div>
                ))}
              </div>
              <div className="p-6 bg-gray-50 flex flex-wrap gap-8 text-sm">
                <div>
                  <strong>Duration:</strong> 3 Years
                </div>
                <div>
                  <strong>Fee:</strong> ₹25,000/- per year
                </div>
                <div>
                  <strong>Admission:</strong> POLYCET Counseling
                </div>
              </div>
            </section>

            {/* 6. Infrastructure Stats */}
            <section>
              <h2 className="text-xl font-bold mb-6">
                XI. Infrastructure & Resources
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <StatBox
                  label="Library Books"
                  value="20,001"
                  sub="1,532 Titles"
                />
                <StatBox
                  label="Bandwidth"
                  value="900 Mbps"
                  sub="Optical Fiber"
                />
                <StatBox label="Computing" value="132" sub="LAN Connected" />
                <StatBox label="Classrooms" value="26" sub="68 sqm each" />
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

// Reusable components for layout
const Card = ({ title, children }) => (
  <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-200">
    <h3 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4">
      {title}
    </h3>
    {children}
  </div>
);

const StatBox = ({ label, value, sub }) => (
  <div className="bg-white p-6 rounded-2xl border border-gray-200 text-center shadow-sm hover:shadow-md transition">
    <p className="text-xs font-bold text-blue-500 uppercase mb-2">{label}</p>
    <p className="text-3xl font-black text-gray-900">{value}</p>
    <p className="text-[10px] text-gray-400 mt-1 uppercase font-semibold tracking-tighter">
      {sub}
    </p>
  </div>
);

// Helper Components for Organizational Chart
const OrgBox = ({ text, primary, highlight, small, xSmall }) => (
  <div
    className={`
    border-2 px-4 py-3 text-center font-bold uppercase transition-all shadow-sm
    ${primary ? "bg-blue-900 text-white border-blue-900" : "bg-white text-gray-800 border-gray-800"}
    ${highlight ? "ring-4 ring-blue-100 scale-105" : ""}
    ${small ? "text-xs w-48" : xSmall ? "text-[10px] w-36" : "text-sm w-64"}
  `}
  >
    {text}
  </div>
);

const Connector = () => (
  <div className="h-8 w-px bg-blue-200 relative">
    <div className="absolute bottom-0 left-1/2 -translate-x-1/2 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-blue-200"></div>
  </div>
);

export default BoardofGovernors;
